function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getYear, getMonth, setMonth, setYear, format as formatFn, isBefore, startOfMonth, isAfter } from 'date-fns';
import { buildComponentName } from '../utils';
import Select from '../select';
import Radio from '../radio';
export default {
  name: buildComponentName('FullCalendarHeader'),
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    value: {
      type: Date,
      default: null
    },
    validRange: {
      type: Array,
      default: null
    },
    locale: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    yearSelectOffset: {
      type: Number,
      default: 10
    },
    yearSelectTotal: {
      type: Number,
      default: 20
    },
    type: {
      type: String,
      default: 'date'
    }
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return _defineProperty({}, "".concat(prefixCls, "-header"), true);
    },
    size: function size() {
      var fullscreen = this.fullscreen;
      return fullscreen ? 'default' : 'small';
    },
    range: function range() {
      var validRange = this.validRange;

      if (!validRange) {
        return null;
      }

      var _validRange = _slicedToArray(validRange, 2),
          start = _validRange[0],
          end = _validRange[1];

      return {
        start: {
          year: getYear(start),
          month: getMonth(start),
          date: start
        },
        end: {
          year: getYear(end),
          month: getMonth(end),
          date: end
        }
      };
    },
    yearSelect: function yearSelect() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          locale = this.locale,
          size = this.size,
          value = this.value,
          range = this.range,
          yearSelectOffset = this.yearSelectOffset,
          yearSelectTotal = this.yearSelectTotal,
          onYearChange = this.onYearChange;
      var years = [];
      var year = getYear(value);
      var start = year - yearSelectOffset;
      var end = start + yearSelectTotal;

      if (range) {
        var rangeStart = range.start,
            rangeEnd = range.end;
        start = rangeStart.year;
        end = rangeEnd.year + 1;
      }

      var suffix = locale.year === '年' ? '年' : '';

      for (var i = start; i < end; i += 1) {
        years.push({
          value: i,
          label: "".concat(i).concat(suffix)
        });
      }

      return h(Select, {
        "attrs": {
          "size": size,
          "dataSource": years,
          "dropdownMatchSelectWidth": false,
          "value": year
        },
        "class": "".concat(prefixCls, "-year-select"),
        "on": {
          "input": onYearChange
        }
      });
    },
    monthSelect: function monthSelect() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          locale = this.locale,
          size = this.size,
          value = this.value,
          range = this.range,
          onMonthChange = this.onMonthChange;
      var months = [];
      var year = getYear(value);
      var month = getMonth(value);
      var start = 0;
      var end = 12;

      if (range) {
        var rangeStart = range.start,
            rangeEnd = range.end; // 对于 有效日期上限和下限, 分别动态获取有效月份

        if (year === rangeStart.year) {
          start = rangeStart.month;
        }

        if (year === rangeEnd.year) {
          end = rangeEnd.month + 1;
        }
      }

      for (var i = start; i < end; i += 1) {
        months.push({
          value: i,
          label: formatFn(setMonth(value, i), 'MMM', {
            locale: locale.DateFnsLocale
          })
        });
      }

      return h(Select, {
        "attrs": {
          "size": size,
          "dropdownMatchSelectWidth": false,
          "lazy": false,
          "dataSource": months,
          "value": month
        },
        "class": "".concat(prefixCls, "-month-select"),
        "on": {
          "input": onMonthChange
        }
      });
    },
    typeSwitch: function typeSwitch() {
      var h = this.$createElement;
      var type = this.type,
          locale = this.locale,
          size = this.size,
          onTypeChange = this.onTypeChange;
      return h(Radio.Group, {
        "attrs": {
          "size": size,
          "value": type
        },
        "on": {
          "change": onTypeChange
        }
      }, [h(Radio.Button, {
        "attrs": {
          "value": "date"
        }
      }, [locale.month]), h(Radio.Button, {
        "attrs": {
          "value": "month"
        }
      }, [locale.year])]);
    }
  },
  methods: {
    onTypeChange: function onTypeChange(val) {
      this.$emit('type-change', val);
    },
    onYearChange: function onYearChange(val) {
      var range = this.range;
      var nDate = setYear(this.value, val);

      if (range) {
        var _range$start = range.start,
            startDate = _range$start.date,
            startMonth = _range$start.month,
            _range$end = range.end,
            endDate = _range$end.date,
            endMonth = _range$end.month;
        var nDateMonth = startOfMonth(nDate);

        if (isBefore(nDateMonth, startOfMonth(startDate))) {
          nDate = setMonth(nDate, startMonth);
        }

        if (isAfter(nDateMonth, startOfMonth(endDate))) {
          nDate = setMonth(nDate, endMonth);
        }
      }

      this.$emit('change', nDate);
    },
    onMonthChange: function onMonthChange(val) {
      var nDate = setMonth(this.value, val);
      this.$emit('change', nDate);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        type = this.type,
        yearSelect = this.yearSelect,
        monthSelect = this.monthSelect,
        typeSwitch = this.typeSwitch;
    return h("div", {
      "class": classes
    }, [yearSelect, type === 'date' ? monthSelect : null, typeSwitch]);
  }
};